module.exports = __webpack_public_path__ + "img/face.b26a719d.png";